import { fork, take, call, put, all } from "redux-saga/effects";

import { getExternalTrainersResponse, getInternalTrainersResponse, getMembersResponse, getTrainersResponse, getWorkshopResponse, postWorkshopResponse, postWorkshopTimezoneResponse, updateWorkshopDataResponse, updateWorkshopResponse } from "./actions";
import types from "./types"
import { apiDirect, postAPIWithoutModule } from "../../api/generic";


export function* doTrainersList() {
  while (true) {
    const { payload } = yield take(types.GET_TRAINERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTrainersResponse(response));
  }
}

export function* doInternalTrainersList() {
  while (true) {
    const { payload } = yield take(types.GET_INTERNAL_TRAINERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getInternalTrainersResponse(response));
  }
}

export function* doExternalTrainersList() {
  while (true) {
    const { payload } = yield take(types.GET_EXTERNAL_TRAINERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getExternalTrainersResponse(response));
  }
}

export function* doMembersList() {
  while (true) {
    const { payload } = yield take(types.GET_MEMBERS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getMembersResponse(response));
  }
}

export function* doGroupSubmit() {
  while (true) {
    const { payload } = yield take(types.POST_WORKSHOP_SUBMIT);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(postWorkshopResponse(response));
  }
}

export function* doGroupTimezone() {
  while (true) {
    const { payload } = yield take(types.POST_WORKSHOP_TIMEZONE);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(postWorkshopTimezoneResponse(response));
  }
}

export function* doUpdateGroupWorkshop() {
  while (true) {
    const { payload } = yield take(types.UPDATE_WORKSHOP);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(updateWorkshopResponse(response));
  }
}

export function* doGetGroupWorkshop() {
  while (true) {
    const { payload } = yield take(types.GET_WORKSHOP_DATA);
    const response = yield call(apiDirect, payload);
    yield put(getWorkshopResponse(response));
  }
}

export function* doUpdateGroupWorkshopData() {
  while (true) {
    const { payload } = yield take(types.UPDATE_WORKSHOP_DATA);
    const response = yield call(apiDirect, payload);
    yield put(updateWorkshopDataResponse(response));
  }
}


function* groupWorkshop() {
  yield fork(doTrainersList);
  yield fork(doInternalTrainersList);
  yield fork(doExternalTrainersList);
  yield fork(doMembersList)
  yield fork(doGroupSubmit)
  yield fork(doGroupTimezone)
  yield fork(doUpdateGroupWorkshop)
  yield fork(doGetGroupWorkshop)
  yield fork(doUpdateGroupWorkshopData)

}

export default groupWorkshop;